<template>
  <div>
      <b-row>
          <b-col cols="12">
              <div class="solution-steps">
                  <b-tabs pills content-class="mt-4" align="center">
                      <b-tab title="Calculate" @click="emitEvent('reset-shows-props', 'reset-select-product')">
                      </b-tab>
                      <b-tab title="Solicitor" :active="showSolicitorSelection" @click="emitEvent('show-solicitor-selection')">
                          <SolicitorSelection />
                      </b-tab>
                      <b-tab title="Summary" :active="showSolicitorSummary" @click="emitEvent('show-solicitor-summary')">
                          <SolicitorSummary />
                      </b-tab>
                  </b-tabs>
              </div>
          </b-col>
      </b-row>
  </div>
</template>
<script>
import { Tabs, TabPane } from 'element-ui'
import solutionEventBus from '@/assets/js/EventBus/solutionEventBus.js'
import SolicitorSelection from '@/views/CustomerProfile/CustomerProfileDetails/OffCanvasDetails/DrawerSolutionScenario/SolicitorSolution/SolicitorSelection'
import SolicitorSummary from '@/views/CustomerProfile/CustomerProfileDetails/OffCanvasDetails/DrawerSolutionScenario/SolicitorSolution/SolicitorSummary'
export default {
  props: {
      showSolicitorCompanies: Boolean,
      showSolicitorSelection: Boolean,
      showSolicitorSummary: Boolean,
  },
  components: {
      SolicitorSelection,
      SolicitorSummary,
      [Tabs.name]: Tabs,
      [TabPane.name]: TabPane,
  },
  methods: {
      emitEvent(...eventNames) {
          eventNames.forEach(eventName => {
              solutionEventBus.$emit(eventName)
          })
      }
  },
}
</script>